import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PROPERTY } from "./apiRoutes";

interface UseGetPropertiesByCommunityAndUserProps {
  queryParams?: Omit<UseQueryOptions, "queryKey">;
  communityId: string;
}

const getPropertiesByCommunityAndUser = async (communityId: string) =>
  await axiosAuth.get(`${PROPERTY(communityId)}/assign/user`);

const useGetPropertiesByCommunityAndUser = ({
  queryParams,
  communityId,
}: UseGetPropertiesByCommunityAndUserProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["properties-community-user", communityId],
    queryFn: () => getPropertiesByCommunityAndUser(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetPropertiesByCommunityAndUser;
